<template>
    <div id="ambis-meter">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Ambis Test' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <h3 class="header-text font-weight-bold">Ambis Test</h3>

        <v-card>
            <v-card-title>
                Daftar Tema Skala
                <v-spacer></v-spacer>

                <v-btn
                    class="align-center text-body-2 blew white--text"
                    depressed
                    @click="createAmbisTest()"
                >
                    <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tambah Tema Skala
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="row"
                :headers="headers"
                :has-action="true"
                :has-edit="true"
                :has-leaderboard="true"
                :key="tableKey"
                :customWidth="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-total-items="total_data"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                :row-expanded-detail="row"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="detailTheme()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:updateItem="editTheme()"
                v-on:deleted="confirmDeleteItem($event)"
                v-on:doSearch="
                    search = {
                        query: $event.value,
                        by: headersKey[$event.key],
                    };
                    doSearch();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>

        <v-dialog v-model="confirmDialog" persistent max-width="450">
            <dialog-confirm
                :title="'Hapus Tema Skala'"
                :subtitle="'Apakah anda akan menghapus Tema ini ?'"
                @close="confirmDialog = false"
                @confirm="deleteItem()"
            />
        </v-dialog>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import AmbisTestService from "@/modules/ambis_test/services/ambis_test.js";
// import Moment from "moment";
import ambis_test from "../services/ambis_test";
import DialogConfirm from "@/modules/global/components/DialogConfirm";

export default {
    name: "ambis-test",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
        "dialog-confirm": DialogConfirm,
    },

    data: function () {
        return {
            isLoading: false,
            isLoadingForm: false,
            selectedRow: null,
            confirmDialog: false,
            search: "",
            tableKey: 0,
            total_data: 0,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            params: {
                sortMode: "desc",
                theme_name: "",
                theme_description: "",
                target_user: "",
            },
            row: [],
            headers: [
                { text: "Gambar", value: "picture", width: "170px" },
                { text: "Deskripsi", value: "theme_description" },
                { text: "Aksi", value: "actions", width: "150px" },
            ],
            headersKey: ["name", "description"],
        };
    },

    watch: {
        pagination() {
            this.getListTheme();
        },
    },

    mounted: function () {
        this.getListTheme();
    },

    methods: {
        getListTheme: function () {
            var context = this;
            context.params.page = context.pagination.currentPage;
            context.params.size = context.pagination.perPage;

            context.isLoading = true;

            AmbisTestService.getListTheme(context.params, (result) => {
                context.row = [];

                if (result) {
                    context.total_data = result.data.total_data;
                    context.pagination.totalPages = result.data.max_page;

                    result.data.data.forEach(function (response, index) {
                        var row = {
                            no: index,
                            id: response.id,
                            name: response.theme_name,
                            description: response.theme_description,
                            picture: response.theme_picture,
                            target_user: response.target_user,
                            total_scale: response.total_scale,
                        };

                        context.row.push(row);
                        context.row = _.orderBy(context.row, "id", "desc");
                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        createAmbisTest: function () {
            this.$router.push({ path: "/theme-form" });
        },

        detailTheme: function () {
            var context = this;
            var id = context.selectedRow.id;

            context.$router.push({
                path: "/detail-skala",
                query: {
                    id: id,
                    name: context.selectedRow.name,
                    target_user: context.selectedRow.target_user,
                },
            });
        },

        editTheme: function () {
            var context = this;
            var id = context.selectedRow.id;

            context.$router.push({
                path: "/theme-form",
                query: {
                    id: id,
                },
            });
        },

        doSearch() {
            this.params.page = 1;
            this.pagination.currentPage = 1;

            this.params.theme_description = this.search.query;

            this.getListTheme();
        },

        clearFilter() {
            this.params = {
                page: 1,
                per_page: this.pagination.perPage,
                name: "",
                description: "",
                sort: "",
            };
        },

        confirmDeleteItem(val) {
            this.selectedRow = val;
            this.confirmDialog = true;
        },

        deleteItem() {
            var context = this;
            const id = context.selectedRow.id;

            context.isLoadingForm = true;

            ambis_test.deleteTheme(id, function (result) {
                if (result.success) {
                    context.confirmDialog = false;
                    context.getListTheme();
                    context.isLoadingForm = false;
                } else {
                    context.isLoadingForm = false;
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// AmbisTest.vue?d1cfca6a